import { render, staticRenderFns } from "./login - 副本.vue?vue&type=template&id=209b023b&scoped=true"
import script from "./login - 副本.vue?vue&type=script&lang=js"
export * from "./login - 副本.vue?vue&type=script&lang=js"
import style0 from "./login - 副本.vue?vue&type=style&index=0&id=209b023b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209b023b",
  null
  
)

export default component.exports